import "./ResidentPending.css";

export default function ResidentPending() {
  return (
    <div className="pending-shell">
      <div className="pending-card">
        <h1>Your registration is pending approval</h1>
        <p>Here's what happens next:</p>
        <ol className="pending-steps">
          <li>
            <strong>Verify your email.</strong> We've sent a verification link
            to the email address you registered with. Click it to confirm
            your address (the link expires in 24 hours).
          </li>
          <li>
            <strong>Wait for Tower Admin approval.</strong> Once your email is
            verified, our admin team will review your details.
          </li>
          <li>
            <strong>Get notified.</strong> You'll receive an activation email
            as soon as your account is approved — after that, you can log in
            to the portal with the credentials you just created.
          </li>
        </ol>
        <p className="pending-note">
          Didn't get the verification email? Check your spam folder. If it's
          been more than a few minutes, contact the admin office for help.
        </p>
      </div>
    </div>
  );
}